import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);

  const [storeDetail, setStoreDetail] = useState(null);
  const [profilePhotoError, setProfilePhotoError] = useState(false);

  useEffect(() => {
    const storeDetail = JSON.parse(localStorage.getItem("storeDetail"));
    if (storeDetail) {
      setStoreDetail(storeDetail);
      setProfilePhotoError(false);
    }
  }, [props.success]);

  const storeInitial = storeDetail?.name?.trim()?.charAt(0)?.toUpperCase() || "?";
  const showProfilePhoto = storeDetail?.profilePhoto && !profilePhotoError;

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item d-inline-flex align-items-center"
          id="page-header-user-dropdown"
          tag="button"
        >
          {showProfilePhoto ? (
            <img
              className="rounded-circle header-profile-user"
              src={storeDetail.profilePhoto}
              alt={storeDetail?.name || "Commerce"}
              onError={() => setProfilePhotoError(true)}
            />
          ) : (
            <span className="rounded-circle bg-primary text-white header-profile-user header-profile-user-fallback fw-bold">
              {storeInitial}
            </span>
          )}
          <span className="d-none d-xl-inline-block ms-2 me-1 fw-bold">{storeDetail?.name ?? ''}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem tag="a" href="change-password">
            <i className="bx bx-lock-open font-size-16 align-middle me-1" />
            {props.t("Changer votre mot de passe")}
          </DropdownItem>
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Déconnexion")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
